import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ListReportPublishers from "./List";

//params
export const REPORT_AUTORS = "publishers/reference";

//permissions

export const resources = {
  isMenu: true,
  icon: <AccountBoxIcon />,
  name: REPORT_AUTORS,
  title: "Справка издатели",
  list: <ListReportPublishers />,
  permission: "editions",
};

//api url
